<template>
  <div class="gender-switch">
    <div
      class="gender-switch__gender"
      :class="{ 'gender-switch__gender--active': this.changeableValue < 0 }"
    >
      {{ $t('genders')['male'] }}
    </div>
    <div class="gender-switch__switch switch">
      <vue-slider
        ref="slider"
        :min="-100"
        :max="100"
        :tooltip="'none'"
        :height="height"
        :dot-width="dotWidth"
        :dot-height="dotHeight"
        v-model="changeableValue"
      >
        <div class="diy-dot" slot="dot"></div>
      </vue-slider>
    </div>
    <div
      class="gender-switch__gender"
      :class="{ 'gender-switch__gender--active': this.changeableValue > 0 }"
    >
      {{ $t('genders')['female'] }}
    </div>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component';

export default {
  components: {
    vueSlider,
  },

  props: {
    value: String,
  },

  data() {
    return {
      changeableValue: this.value,
      dotWidth: 14,
      dotHeight: 19,
      height: 2,
    };
  },

  watch: {
    changeableValue() {
      this.isError = false;
      this.$emit('input', this.changeableValue.toString());
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/variables';

.gender-switch {
  display: flex;
  font-family: GilroyMedium;
  margin: 20px 0 40px 0;

  &__gender {
    cursor: default;
    font-size: 32px;
    color: $gray;

    &--active {
      color: $black;
    }
  }

  &__switch {
    width: 188px;
    margin: 3px 9px 0;
  }

  .switch {
    .diy-dot {
      width: 14px;
      height: 19px;
      background-image: url('./handle.png');
      position: relative;
    }
  }

  .vue-slider-component {
    .vue-slider-process {
      background-color: $gray;
    }
  }

  .vue-slider {
    cursor: pointer;
    padding-top: 15px !important;
  }

  .vue-slider-disabled {
    cursor: default;
  }

  .vue-slider-rail {
    background: $light-gray;
  }
}
</style>
